var classList = require('dom-classlist');
var gsap = require('gsap');
var pubsub = require('pubsub');

// Variables
var canToggle = true,
    opened = false,
    hoverTimline,
    _close = document.querySelector('.nav-main .close');
    _navMain = document.querySelector('.nav-main'),
    _navMainItems = _navMain.querySelectorAll('.nav-main__main-list__item'),
	_menuBurger = document.querySelector('.menu-prompt');

// Menu Main TimeLine
var tlMainMenu = new TimelineLite({paused:true});

tlMainMenu.add( TweenMax.to(_navMain, 0.6, { opacity : 1, ease: Power2.easeInOut }));
tlMainMenu.add(	TweenMax.staggerFrom(_navMainItems, 0.3, { y:"+=100", opacity: 0,  ease: Power2.easeInOut }, 0.06), "-=0.55");

// Add class hidden (visibility:hidden) to navMain when close menu annimation ended
tlMainMenu.eventCallback("onReverseComplete", function() {
	classList(_navMain).add('hidden');
});


// Menu Main TimeLine
TweenLite.defaultEase = Power1.easeOut;

var strokes = Array.prototype.slice.apply(document.querySelectorAll('.stroke'))
var tlBurger = new TimelineLite({paused:true})
var d = 0.4 // hover tweens duration

var stroke1 = function(){
    var stroke = strokes[0];
    var tl = new TimelineLite();
    var points = [];

    for (var i = 0; i < 4; i++) {
        points[i] = stroke.points.getItem(i)
    }

    tl.to( [ points[2], points[3] ] , d, { y : 2 } )
    tl.to( [ points[1], points[2] ] , d, { x : 16 } )

    return tl
}

var stroke2 = function(){
    var stroke = strokes[1];
    var tl = new TimelineLite();
    var points = [];

    for (var i = 0; i < 4; i++) {
        points[i] = stroke.points.getItem(i)
    }

    tl.to( [ points[0], points[1] ] , d, { y : 9 })
    tl.to( [ points[2], points[3] ] , d, { y : 11 }, "-="+d)

    tl.to( [ points[0], points[3] ] , d, { x : -7 })
    tl.to( [ points[1], points[2] ] , d, { x : 9 }, "-="+d)

    return tl
}

var stroke3 = function(){
    var stroke = strokes[2];
    var tl = new TimelineLite();
    var points = [];

    for (var i = 0; i < 4; i++) {
        points[i] = stroke.points.getItem(i)
    }

    tl.to( [ points[0], points[1] ] , d, { y : 18 } )
    tl.to( [ points[0], points[3] ] , d, { x : -14 } )

    return tl
}

tlBurger.add(stroke1(), 0)
tlBurger.add(stroke2(), 0)
tlBurger.add(stroke3(), 0)

TweenLite.set(strokes[0], { x: -3 })
TweenLite.set(strokes[1], { x: 7 })
TweenLite.set(strokes[2], { x: 17 })

var introTween = function(){
    var tl = new TimelineLite()

    tl.to(strokes[0], 0.3, { ease: Linear.easeNone, x: 0 }, 0)
    tl.to(strokes[1], 0.3, { ease: Linear.easeNone, x: 7 }, 0)
    tl.to(strokes[2], 0.3, { ease: Linear.easeNone, x: 14 }, 0)

  return tl;
}();

var hoverTween = function(state) {
    if(state == "enter") {
        if(!opened) {
            hoverTimline = new TimelineLite({paused: true})
            hoverTimline.to(strokes[0], 0.3, { ease: Linear.easeNone, x: -3 }, 0)
            hoverTimline.to(strokes[2], 0.3, { ease: Linear.easeNone, x: 17 }, 0)
        }else{
            hoverTimline = new TimelineLite({paused: true})
            hoverTimline.to(strokes[0], 0.3, { ease: Linear.easeNone, y: -3 }, 0)
            hoverTimline.to(strokes[2], 0.3, { ease: Linear.easeNone, y: 3 }, 0)
        }
        hoverTimline.play();
    }else {
        hoverTimline.reverse();
    }
};
 
_menuBurger.addEventListener('click', function(e) {
	e.preventDefault();

	if(!classList(this).contains('active')){
		classList(_navMain).remove('hidden');
		openMainMenu();
	}else{
		closeMainMenu();
	}

    classList(this).toggle('active');
	canToggle = false;
});

_close.addEventListener('click', function(e) {
	closeMainMenu();

    classList(_menuBurger).toggle('active');
    canToggle = false;
    pubsub.emit('search:close');
});

if(!G.isMobile) {
    _menuBurger.addEventListener('mouseenter', function(){
        hoverTween("enter");
    });

    _menuBurger.addEventListener('mouseleave', function(){
        hoverTween("leave");
    });
}


document.onkeyup = function(e) {
	var open = classList(_menuBurger).contains('active');
    if (e.keyCode == 27 && open) {
     	closeMainMenu();
    }
};


pubsub.on('document:ready', function(){
    setTimeout(function() {
       introTween.play();
    }, 400);
});

function openMainMenu() {
	tlMainMenu.play();
	tlBurger.play()
    classList(G._html).add('no-scroll');
    // Remove scroll for touch devices
    document.ontouchmove = function(e){
        e.preventDefault();
    }
    opened = true;
}

function closeMainMenu() {

    tlMainMenu.reverse();

	tlMainMenu.reverse();
	tlBurger.reverse();
    classList(G._html).remove('no-scroll');
    // Readd scroll for touch devices
    document.ontouchmove = function(e){
    }
    opened = false;
}